import { render, staticRenderFns } from "./NutsvoorzieningenEnComfort.vue?vue&type=template&id=c5215296"
import script from "./NutsvoorzieningenEnComfort.vue?vue&type=script&lang=js"
export * from "./NutsvoorzieningenEnComfort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports